function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "transparent",
  stroke: "#C1A36E",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.065 22.832c5.968 0 10.768-4.8 10.768-10.768 0-5.968-4.8-10.768-10.768-10.768A10.743 10.743 0 0 0 1.297 12.065c-.13 5.838 4.8 10.768 10.768 10.768zm0-6.486v-4.411m0-4.281h0",
  style: {
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
}));
SvgInfoCircle.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircle);
export default ForwardRef;